import React from 'react';

/* ── Confirm dialog ─────────────────────────────────────── */
export function Confirm({ title, msg, confirmLabel = 'Confirm', danger, onCancel, onConfirm }) {
  return (
    <div className="overlay" onClick={e => e.target === e.currentTarget && onCancel()}>
      <div className="modal" style={{ maxWidth: 380 }}>
        <h3>⚠ {title}</h3>
        <p style={{ color: 'var(--sub)', fontSize: 14, lineHeight: 1.65, marginBottom: 4 }}>{msg}</p>
        <div className="modal-footer">
          <button className="btn btn-ghost" onClick={onCancel}>Cancel</button>
          <button className={`btn ${danger ? 'btn-danger' : 'btn-primary'}`} onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

/* ── Password strength bar ──────────────────────────────── */
export function StrengthBar({ password }) {
  if (!password) return null;
  let s = 0;
  if (password.length >= 8) s++;
  if (/[A-Z]/.test(password)) s++;
  if (/[0-9]/.test(password)) s++;
  if (/[^A-Za-z0-9]/.test(password)) s++;
  const labels = ['', 'Weak', 'Fair', 'Good', 'Strong'];
  const colors = ['', 'var(--red)', 'var(--amber)', '#84cc16', 'var(--green)'];
  return (
    <>
      <div className="str-bars">
        {[1, 2, 3, 4].map(i => (
          <div key={i} className={`str-bar${s >= i ? ` on-${s}` : ''}`} />
        ))}
      </div>
      <div style={{ fontSize: 11, marginTop: 4, color: colors[s] }}>{labels[s]}</div>
    </>
  );
}

/* ── Color picker ───────────────────────────────────────── */
export const GROUP_COLORS = [
  '#3b82f6','#7c3aed','#10b981','#f59e0b','#ef4444',
  '#06b6d4','#f97316','#ec4899','#84cc16','#6366f1',
];

export function ColorPicker({ value, onChange }) {
  return (
    <div className="color-picker">
      {GROUP_COLORS.map(c => (
        <div
          key={c}
          className={`cpick${value === c ? ' sel' : ''}`}
          style={{ background: c }}
          onClick={() => onChange(c)}
        />
      ))}
    </div>
  );
}

/* ── Copy button ────────────────────────────────────────── */
export function CopyBtn({ text, label = '📋', onCopied }) {
  const [copied, setCopied] = React.useState(false);
  const handle = (e) => {
    e.stopPropagation();
    navigator.clipboard.writeText(text || '').then(() => {
      setCopied(true);
      onCopied && onCopied();
      setTimeout(() => setCopied(false), 1800);
    });
  };
  return (
    <button className="copy-btn" onClick={handle} title="Copy to clipboard">
      {copied ? '✅' : label}
    </button>
  );
}

/* ── Log action badge ───────────────────────────────────── */
const LOG_CLS = {
  login: 'b-purple', logout: 'b-gray',
  view: 'b-cyan',    copy: 'b-blue',
  add: 'b-green',    edit: 'b-amber',
  delete: 'b-red',
  group_create: 'b-green', group_edit: 'b-amber', group_delete: 'b-red',
  user_create: 'b-green',  user_edit: 'b-amber',  user_delete: 'b-red',
};
export function LogBadge({ action }) {
  return <span className={`badge ${LOG_CLS[action] || 'b-gray'}`}>{action}</span>;
}

/* ── Small user avatar ──────────────────────────────────── */
export function Avatar({ username, color, size = 30 }) {
  return (
    <div style={{
      width: size, height: size, borderRadius: '50%', flexShrink: 0,
      background: color || 'var(--accent)', color: '#fff',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontWeight: 800, fontSize: size * 0.4,
    }}>
      {(username || '?').slice(0, 2).toUpperCase()}
    </div>
  );
}

/* ── Loading spinner ────────────────────────────────────── */
export function Spinner() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '60px 20px' }}>
      <div style={{
        width: 32, height: 32, borderRadius: '50%',
        border: '3px solid var(--border2)',
        borderTopColor: 'var(--accent)',
        animation: 'spin .7s linear infinite',
      }} />
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );
}
